"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _appActions = require("../appActions");
var _recommendationActions = require("./recommendationActions");
var _utils = require("../../utils/utils");
var _questionnaireActions = require("../questionnaire/questionnaireActions");
var _constants = require("../../utils/constants");
const initialState = {
  isRecommendationFetched: false,
  recommendationRawData: [],
  handsets: [],
  plans: [],
  additionalPlans: 0,
  pricesCosts: null,
  broadbands: [],
  businessSolutions: [],
  selectedHandsetId: '',
  selectedPlanId: '',
  selectedBroadbandId: '',
  selectedBusinessSolutionsId: '',
  steps: [],
  currentStep: 1,
  areRecommendationSpecsVisible: false,
  isAddonSelected: true,
  ratingData: {},
  isRecommendationReopen: false
};
const recommendationReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case _recommendationActions.SET_RAW_RECOMMENDATION:
      return {
        ...state,
        recommendationRawData: payload.recommendationResponse
      };
    case _recommendationActions.SET_RECOMMENDATION:
      {
        var _state$handsets, _handsetPayload$find, _plans$find, _broadbands$find, _businessSolutions$fi, _plans$find2, _plans$find2$selected, _plans$find2$selected2, _plans$find2$selected3, _plans$find2$selected4, _plans$find2$selected5;
        const {
          handsets,
          plans,
          broadbands,
          businessSolutions
        } = payload.recommendationData;
        const stateHandSetIds = (_state$handsets = state.handsets) === null || _state$handsets === void 0 ? void 0 : _state$handsets.map(handset => handset.productId);
        const handsetIds = handsets === null || handsets === void 0 ? void 0 : handsets.map(handset => handset.productId);
        const shouldUseStateHandsets = stateHandSetIds.length === handsetIds.length && stateHandSetIds.every(element => handsetIds.includes(element));
        const handsetPayload = shouldUseStateHandsets ? state.handsets : handsets;
        const selectedHandsetId = handsetPayload === null || handsetPayload === void 0 ? void 0 : (_handsetPayload$find = handsetPayload.find(handset => {
          return handset.tier === 'recommended';
        })) === null || _handsetPayload$find === void 0 ? void 0 : _handsetPayload$find.productId;
        const selectedPlanId = plans === null || plans === void 0 ? void 0 : (_plans$find = plans.find(handset => {
          return handset.tier === 'recommended';
        })) === null || _plans$find === void 0 ? void 0 : _plans$find.productId;
        const selectedBroadbandId = broadbands === null || broadbands === void 0 ? void 0 : (_broadbands$find = broadbands.find(broadband => {
          return broadband.tier === 'recommended';
        })) === null || _broadbands$find === void 0 ? void 0 : _broadbands$find.productId;
        const selectedBusinessSolutionsId = businessSolutions === null || businessSolutions === void 0 ? void 0 : (_businessSolutions$fi = businessSolutions.find(broadband => {
          return broadband.tier === 'recommended';
        })) === null || _businessSolutions$fi === void 0 ? void 0 : _businessSolutions$fi.productId;
        const numberOfPlans = Number((plans === null || plans === void 0 ? void 0 : (_plans$find2 = plans.find(handset => {
          return handset.tier === 'recommended';
        })) === null || _plans$find2 === void 0 ? void 0 : (_plans$find2$selected = _plans$find2.selectedVariant) === null || _plans$find2$selected === void 0 ? void 0 : (_plans$find2$selected2 = _plans$find2$selected.characteristics) === null || _plans$find2$selected2 === void 0 ? void 0 : (_plans$find2$selected3 = _plans$find2$selected2.find(characteristic => {
          return characteristic.name == _constants.ADDITIONAL_PLANS_CHARACTERISTIC;
        })) === null || _plans$find2$selected3 === void 0 ? void 0 : (_plans$find2$selected4 = _plans$find2$selected3.value) === null || _plans$find2$selected4 === void 0 ? void 0 : (_plans$find2$selected5 = _plans$find2$selected4[0]) === null || _plans$find2$selected5 === void 0 ? void 0 : _plans$find2$selected5.value) || 1);
        return {
          ...state,
          handsets: handsetPayload,
          plans,
          broadbands,
          businessSolutions,
          selectedHandsetId: state.selectedHandsetId || selectedHandsetId || '',
          selectedPlanId: state.selectedPlanId || selectedPlanId || '',
          selectedBroadbandId: state.selectedBroadbandId || selectedBroadbandId || '',
          selectedBusinessSolutionsId: state.selectedBusinessSolutionsId || selectedBusinessSolutionsId || '',
          additionalPlans: state.additionalPlans === null ? numberOfPlans - 1 : state.additionalPlans
        };
      }
    case _questionnaireActions.RESET_QUESTIONNAIRE:
      return initialState;
    case _recommendationActions.UNSET_RECOMMENDATION:
      return {
        ...state,
        handsets: initialState.handsets,
        plans: initialState.plans,
        broadbands: initialState.broadbands,
        businessSolutions: initialState.businessSolutions,
        selectedHandsetId: null,
        selectedPlanId: null,
        selectedBroadbandId: null,
        selectedBusinessSolutionsId: null,
        isRecommendationReopen: false
      };
    case _questionnaireActions.RESET_BUDGET_AND_RECOMMENDATION:
      return {
        ...(0, _utils.clone)(initialState),
        additionalPlans: state.additionalPlans
      };
    case _recommendationActions.UPDATE_SELECTED_HANDSET:
      {
        return {
          ...state,
          selectedHandsetId: payload.productId
        };
      }
    case _recommendationActions.UPDATE_SELECTED_VARIANT:
      {
        const handsets = state.handsets.map(handset => {
          if (handset.productId === payload.productId) {
            const selectedVariant = handset.variants.find(variant => variant.variantId === payload.variantId);
            return {
              ...handset,
              productName: selectedVariant.productName,
              selectedVariant
            };
          }
          return handset;
        });
        return {
          ...state,
          handsets
        };
      }
    case _recommendationActions.UPDATE_SELECTED_PLAN:
      {
        return {
          ...state,
          selectedPlanId: payload.productId
        };
      }
    case _recommendationActions.UPDATE_SELECTED_BROADBAND:
      {
        return {
          ...state,
          selectedBroadbandId: payload.productId
        };
      }
    case _recommendationActions.UPDATE_SELECTED_BUSINESS_SOLUTION:
      {
        return {
          ...state,
          selectedBusinessSolutionsId: payload.productId
        };
      }
    case _appActions.INJECT_STATE:
      return {
        ...state,
        ...payload.recommendation
      };
    case _recommendationActions.SET_STEPS:
      return {
        ...state,
        steps: payload.steps
      };
    case _recommendationActions.SET_STEP:
      return {
        ...state,
        currentStep: payload.step
      };
    case _recommendationActions.GO_TO_NEXT_STEP:
      return {
        ...state,
        currentStep: state.currentStep + 1
      };
    case _recommendationActions.GO_TO_PREVIOUS_STEP:
      return {
        ...state,
        currentStep: state.currentStep - 1
      };
    case _recommendationActions.FETCH_RECOMMENDATION_SUCCESS:
      return {
        ...state,
        isRecommendationFetched: true
      };
    case _recommendationActions.SET_ADDITIONAL_PLANS:
      return {
        ...state,
        additionalPlans: payload.additionalPlans
      };
    case _recommendationActions.SET_PRICES_COSTS:
      return {
        ...state,
        pricesCosts: payload.costs
      };
    case _recommendationActions.SET_ARE_RECOMMENDATION_SPECS_VISIBLE:
      return {
        ...state,
        areRecommendationSpecsVisible: payload.areRecommendationSpecsVisible
      };
    case _recommendationActions.SET_IS_ADDON_SELECTED:
      return {
        ...state,
        isAddonSelected: payload.isAddonSelected
      };
    case _recommendationActions.SET_RATING:
      return {
        ...state,
        ratingData: {
          ...state.ratingData,
          [payload.ratingData.productId]: payload.ratingData.rating
        }
      };
    case _recommendationActions.CLEAR_RATING:
      return {
        ...state,
        ratingData: {}
      };
    case _recommendationActions.REOPEN_RECOMMENDATION:
      return {
        ...state,
        isRecommendationReopen: true
      };
    default:
      return state;
  }
};
var _default = recommendationReducer;
exports.default = _default;